/* eslint-disable import/no-cycle */
import { ComponentIdentifierEnum, FormFieldsEnum } from '@flowx/core-sdk'

import { FlxAlertWrapperComponent } from './alert-wrapper/alert-wrapper.component'
import { FlxAvatarWrapperComponent } from './avatar-wrapper/avatar-wrapper.component'
import { FlxBadgeWrapperComponent } from './badge-wrapper/badge-wrapper.component'
import { FlxBulkFileUploadWrapperComponent } from './bulk-file-upload-wrapper/bulk-file-upload-wrapper.component'
import { FlxButtonWrapperComponent } from './button-wrapper/button-wrapper.component'
import { FlxChartWrapperComponent } from './chart-wrapper/chart-wrapper.component'
import { FlxChatWrapperComponent } from './chat-wrapper/chat-wrapper.component'
import { FlxCheckboxWrapperComponent } from './checkbox-wrapper/checkbox-wrapper.component'
import { FlxDatepickerWrapperComponent } from './datepicker-wrapper/datepicker-wrapper.component'
import { FlxDescriptionListWrapperComponent } from './description-list-wrapper/description-list-wrapper.component'
import { FlxDocumentPreviewWrapperComponent } from './document-preview-wrapper/document-preview-wrapper.component'
import { FlxDownloadWrapperComponent } from './download-wrapper/download-wrapper.component'
import { FlxEmptyStateWrapperComponent } from './empty-state-wrapper/empty-state-wrapper.component'
import { FlxCardFooterActionsWrapperComponent } from './flx-card-footer-actions-wrapper/flx-card-footer-actions-wrapper.component'
import { FlxCardHeaderActionsWrapperComponent } from './flx-card-header-actions-wrapper/flx-card-header-actions-wrapper.component'
import { FlxCardWrapperComponent } from './flx-card-wrapper/flx-card-wrapper.component'
import { FlxCollectionPrototypeComponent } from './flx-collection-prototype/flx-collection-prototype.component'
import { FlxCollectionComponent } from './flx-collection/flx-collection.component'
import { FlxContainerComponent } from './flx-container/flx-container.component'
import { FlxFormComponent } from './flx-form/flx-form.component'
import { FlxImageComponent } from './flx-image/flx-image.component'
import { FlxInputWrapperComponent } from './flx-input-wrapper/flx-input-wrapper.component'
import { FlxLinkComponent } from './flx-link/flx-link.component'
import { FlxPageComponent } from './flx-page/flx-page.component'
import { FlxTaskManagementWrapperComponent } from './flx-task-management-wrapper/flx-task-management-wrapper.component'
import { FlxTextComponent } from './flx-text/flx-text.component'
import { FlxMarkdownWrapperComponent } from './markdown-wrapper/markdown-wrapper.component'
import { FlxMessageWrapperComponent } from './message-wrapper/message-wrapper.component'
import { FlxModalWrapperComponent } from './modal-wrapper/modal-wrapper.component'
import { FlxMultiSelectWrapperComponent } from './multi-select-wrapper/multi-select-wrapper.component'
import { FlxProgressBarWrapperComponent } from './progress-bar-wrapper/progress-bar-wrapper.component'
import { FlxProgressRingWrapperComponent } from './progress-ring-wrapper/progress-ring-wrapper.component'
import { FlxRadioWrapperComponent } from './radio-wrapper/radio-wrapper.component'
import { FlxRatingWrapperComponent } from './rating-wrapper/rating-wrapper.component'
import { FlxSegmentedButtonWrapperComponent } from './segmented-button-wrapper/segmented-button-wrapper.component'
import { FlxSelectWrapperComponent } from './select-wrapper/select-wrapper.component'
import { FlxSeparatorWrapperComponent } from './separator-wrapper/separator-wrapper.component'
import { FlxSkeletonWrapperComponent } from './skeleton-wrapper/skeleton-wrapper.component'
import { FlxSliderWrapperComponent } from './slider-wrapper/slider-wrapper.component'
import { FlxStatsCardWrapperComponent } from './stats-card-wrapper/stats-card-wrapper.component'
import { FlxStepIndicatorWrapperComponent } from './step-indicator-wrapper/step-indicator-wrapper.component'
import { FlxStepperWrapperComponent } from './stepper-wrapper/stepper-wrapper.component'
import { FlxSwitchWrapperComponent } from './switch-wrapper/switch-wrapper.component'
import { FlxTabBarWrapperComponent } from './tab-bar-wrapper/tab-bar-wrapper.component'
import { FlxTableWrapperComponent } from './table-wrapper/table-wrapper.component'
import { FlxTagGroupWrapperComponent } from './tag-group-wrapper/tag-group-wrapper.component'
import { FlxTextareaWrapperComponent } from './textarea-wrapper/textarea-wrapper.component'
import { FlxTimelineWrapperComponent } from './timeline-wrapper/timeline-wrapper.component'
import { FlxTooltipWrapperComponent } from './tooltip-wrapper/tooltip-wrapper.component'
import { FlxUploadWrapperComponent } from './upload-wrapper/upload-wrapper.component'

export const COMPONENT_WRAPPERS_MAP: Record<string | number, any> = {
  // COMPONENTS
  [ComponentIdentifierEnum.BUTTON]: FlxButtonWrapperComponent,
  [ComponentIdentifierEnum.MESSAGE]: FlxMessageWrapperComponent,
  [ComponentIdentifierEnum.SEPARATOR]: FlxSeparatorWrapperComponent,
  [ComponentIdentifierEnum.TOOLTIP]: FlxTooltipWrapperComponent,
  [ComponentIdentifierEnum.PROGRESS_BAR]: FlxProgressBarWrapperComponent,
  [ComponentIdentifierEnum.MARKDOWN]: FlxMarkdownWrapperComponent,
  [ComponentIdentifierEnum.STATS_CARD]: FlxStatsCardWrapperComponent,
  [ComponentIdentifierEnum.BADGE]: FlxBadgeWrapperComponent,
  [ComponentIdentifierEnum.AVATAR]: FlxAvatarWrapperComponent,
  [ComponentIdentifierEnum.ALERT]: FlxAlertWrapperComponent,
  [ComponentIdentifierEnum.RATING]: FlxRatingWrapperComponent,
  [ComponentIdentifierEnum.TIMELINE]: FlxTimelineWrapperComponent,
  [ComponentIdentifierEnum.EMPTY_STATE]: FlxEmptyStateWrapperComponent,
  [ComponentIdentifierEnum.SKELETON]: FlxSkeletonWrapperComponent,
  [ComponentIdentifierEnum.PROGRESS_RING]: FlxProgressRingWrapperComponent,
  [ComponentIdentifierEnum.DESCRIPTION_LIST]: FlxDescriptionListWrapperComponent,
  [ComponentIdentifierEnum.TAG_GROUP]: FlxTagGroupWrapperComponent,
  [ComponentIdentifierEnum.STEP_INDICATOR]: FlxStepIndicatorWrapperComponent,
  [ComponentIdentifierEnum.CHART]: FlxChartWrapperComponent,
  [ComponentIdentifierEnum.TEXT]: FlxTextComponent,
  [ComponentIdentifierEnum.LINK]: FlxLinkComponent,
  [ComponentIdentifierEnum.IMAGE]: FlxImageComponent,
  [ComponentIdentifierEnum.FILE_UPLOAD]: FlxUploadWrapperComponent,
  [ComponentIdentifierEnum.FILE_DOWNLOAD]: FlxDownloadWrapperComponent,
  [ComponentIdentifierEnum.BULK_FILE_UPLOAD]: FlxBulkFileUploadWrapperComponent,
  [ComponentIdentifierEnum.DOCUMENT_PREVIEW]: FlxDocumentPreviewWrapperComponent,
  [FormFieldsEnum.INPUT]: FlxInputWrapperComponent,
  [FormFieldsEnum.TEXTAREA]: FlxTextareaWrapperComponent,
  [FormFieldsEnum.SWITCH]: FlxSwitchWrapperComponent,
  [FormFieldsEnum.SLIDER]: FlxSliderWrapperComponent,
  [FormFieldsEnum.DATEPICKER]: FlxDatepickerWrapperComponent,
  [FormFieldsEnum.SEGMENTED_BUTTON]: FlxSegmentedButtonWrapperComponent,
  [FormFieldsEnum.RADIO]: FlxRadioWrapperComponent,
  [FormFieldsEnum.CHECKBOX]: FlxCheckboxWrapperComponent,
  [FormFieldsEnum.SELECT]: FlxSelectWrapperComponent,
  [FormFieldsEnum.MULTI_SELECT]: FlxMultiSelectWrapperComponent,
  [ComponentIdentifierEnum.TASK_MANAGEMENT]: FlxTaskManagementWrapperComponent,
  [ComponentIdentifierEnum.CHAT]: FlxChatWrapperComponent,
  // CONTAINERS
  [ComponentIdentifierEnum.CONTAINER]: FlxContainerComponent,
  [ComponentIdentifierEnum.PAGE]: FlxPageComponent,
  [ComponentIdentifierEnum.CARD]: FlxCardWrapperComponent,
  [ComponentIdentifierEnum.CARD_HEADER_ACTIONS]: FlxCardHeaderActionsWrapperComponent,
  [ComponentIdentifierEnum.CARD_FOOTER_ACTIONS]: FlxCardFooterActionsWrapperComponent,
  [ComponentIdentifierEnum.FORM]: FlxFormComponent,
  [ComponentIdentifierEnum.COLLECTION]: FlxCollectionComponent,
  [ComponentIdentifierEnum.COLLECTION_PROTOTYPE]: FlxCollectionPrototypeComponent,
  [ComponentIdentifierEnum.MODAL]: FlxModalWrapperComponent,
  [ComponentIdentifierEnum.ZONE]: FlxContainerComponent,
  [ComponentIdentifierEnum.TAB_BAR]: FlxTabBarWrapperComponent,
  [ComponentIdentifierEnum.STEPPER]: FlxStepperWrapperComponent,
  [ComponentIdentifierEnum.TABLE]: FlxTableWrapperComponent,
}
